<template>
  <div class="mm-col-node">
    <router-link
      :to="linkTo(node.path)"
      class="mm-col-link"
      :class="{ 'is-active': activeId === node.id }"
      @mouseenter.native="$emit('hover', node.id)"
      @click.native="$emit('navigate')"
    >
      {{ node.name }}
    </router-link>

    <div v-if="hasChildren" class="mm-col-children">
      <MegaMenuCategoryColumn
        v-for="child in node.children"
        :key="child.id"
        :node="child"
        :active-id="activeId"
        @hover="(id) => $emit('hover', id)"
        @navigate="$emit('navigate')"
      />
    </div>
  </div>
</template>

<script>
export default {
  // Named so the template can recurse to any depth, mirroring NavCategoryNode.
  name: 'MegaMenuCategoryColumn',
  props: {
    node: { type: Object, required: true },
    activeId: { type: [Number, String], default: null }
  },
  computed: {
    hasChildren() {
      return Array.isArray(this.node.children) && this.node.children.length > 0;
    }
  },
  methods: {
    linkTo(path) {
      return `/c/${String(path || '').split('/').filter(Boolean).join('/')}`;
    }
  }
};
</script>

<style scoped>
.mm-col-node {
  display: block;
}

.mm-col-link {
  display: block;
  padding: 8px 20px;
  color: #333;
  text-decoration: none;
  font-size: 0.88rem;
  white-space: nowrap;
  border-radius: 6px;
  margin: 0 6px;
}

.mm-col-link:hover,
.mm-col-link.is-active {
  background: #f4f7fb;
  color: #1b4b8f;
}

.mm-col-children {
  padding-left: 14px;
}
</style>
